import { createFileRoute } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'

import { useTRPC } from '@/trpc'
import { useAuth } from '@/contexts/AuthContext'
import EditUserForm from '@/pages/users/EditUserForm'

import $form from '@tandem/ui/form.module.css'
import $type from '@tandem/ui/type.module.css'
import $card from '@tandem/ui/card.module.css'
import clsx from 'clsx'
import { useToast } from '@tandem/ui/Toast'
import $ from './settings.module.css'

export const Route = createFileRoute('/settings')({
  component: SettingsPage,
})

function SettingsPage() {
  let trpc = useTRPC()
  let { user: authUser } = useAuth()

  let toast = useToast()

  let userQuery = useQuery(trpc.user.get.queryOptions(authUser?.id ?? 0, {
    enabled: !!authUser?.id,
  }))

  let user = userQuery.data

  if (!authUser || !user) {
    return <div>Загрузка...</div>
  }

  return (
    <div class={clsx('container', $.container)}>
      <h2>Настройки</h2>
      <div class={$card.rect}>
        <EditUserForm user={user} />
      </div>
    </div>
  )
}
